import React from "react";
import { useParams } from "react-router";
import { useEffect } from "react";

import Hero from "../components/aboutPage/hero/Hero";
import Why from "../components/aboutPage/why/Why";
import Mission from "../components/aboutPage/Mission/Mission";

const CONFIG = {
  hr: {
    title: "Metoda i ideja iza tečajeva",
  },
}


const AboutPage = ({ data }) => {
  const { lang } = useParams();


  useEffect(() => {
    document.title = CONFIG[lang]?.title;
    document.getElementsByName("description")[0].content =
      CONFIG[lang]?.description;
  }, [lang]);


  return (
    <>
      <Hero data={data.hero} />
      <Why data={data.why} />
      <Mission data={data.mission} />
    </>
  );
};

export default AboutPage;
